// extracted by mini-css-extract-plugin
export var hidden = "Label-module--hidden--1bc0a";
export var label = "Label-module--label--33e5d";